var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleSheets = function SvgGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.5C22.6547 1.5 24 2.84297 24 4.5V19.5C24 21.1547 22.6547 22.5 21 22.5H3C1.34297 22.5 0 21.1547 0 19.5V4.5C0 2.84297 1.34297 1.5 3 1.5H21ZM10.5 12V7.5H3V12H10.5ZM3 15V19.5H10.5V15H3ZM13.5 19.5H21V15H13.5V19.5ZM21 12V7.5H13.5V12H21Z",
    fill: "#0F9D58"
  })));
};

export { SvgGoogleSheets as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDEuNUMyMi42NTQ3IDEuNSAyNCAyLjg0Mjk3IDI0IDQuNVYxOS41QzI0IDIxLjE1NDcgMjIuNjU0NyAyMi41IDIxIDIyLjVIM0MxLjM0Mjk3IDIyLjUgMCAyMS4xNTQ3IDAgMTkuNVY0LjVDMCAyLjg0Mjk3IDEuMzQyOTcgMS41IDMgMS41SDIxWk0xMC41IDEyVjcuNUgzVjEySDEwLjVaTTMgMTVWMTkuNUgxMC41VjE1SDNaTTEzLjUgMTkuNUgyMVYxNUgxMy41VjE5LjVaTTIxIDEyVjcuNUgxMy41VjEySDIxWiIgZmlsbD0iIzBGOUQ1OCIvPgo8L3N2Zz4K";